import React, { useState } from 'react';
import './GenerateRevisedBillModal.css';

const GenerateRevisedBillModal = ({ onClose, onGenerate }) => {
    const [remarks, setRemarks] = useState([{ text: '', amount: '' }]);
    const [showConfirm, setShowConfirm] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [applyTaxes, setApplyTaxes] = useState(false);
    const maxRemarks = 2; // Set the maximum number of remarks

    const capitalizeWords = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    };

    const handleAddRemark = () => {
        if (remarks.length < maxRemarks) {
            setRemarks([...remarks, { text: '', amount: '' }]);
        } else {
            alert(`Maximum ${maxRemarks} remarks allowed`);
        }
    };

    const handleClearRemarks = () => {
        setRemarks([{ text: '', amount: '' }]);
        setValidationErrors([]);
    };

    const validateRemarks = () => {
        const errors = [];

        remarks.forEach((remark, index) => {
            // Skip validation for empty remark rows
            if (!remark.text.trim() && !remark.amount) return;

            // Validate text
            if (!remark.text.trim()) {
                errors.push(`Remark ${index + 1}: Text is required`);
            } else if (remark.text.trim().length < 3) {
                errors.push(`Remark ${index + 1}: Text must be at least 3 characters`);
            } else if (remark.text.trim().length > 20) {
                errors.push(`Remark ${index + 1}: Text cannot exceed 20 characters`);
            }

            // Validate amount
            if (!remark.amount) {
                errors.push(`Remark ${index + 1}: Amount is required when text is entered`);
            } else if (isNaN(parseFloat(remark.amount))) {
                errors.push(`Remark ${index + 1}: Amount must be a valid number`);
            }
        });

        setValidationErrors(errors);
        return errors.length === 0;
    };

    const handleGenerate = () => {
        if (!validateRemarks()) return;

        // Capitalize remark texts and filter empty remarks
        const filteredRemarks = remarks
            .filter(r => r.text.trim() || r.amount)
            .map(r => ({
                text: capitalizeWords(r.text.trim()),
                amount: parseFloat(r.amount)
            }));

        onGenerate(filteredRemarks, applyTaxes);
    };

    const handleRemarkChange = (index, field, value) => {
        const updated = [...remarks];
        updated[index][field] = value;
        setRemarks(updated);

        // Clear validation errors when user types
        if (validationErrors.length > 0) {
            setValidationErrors([]);
        }
    };

    return (
        <div className="GenerateRevisedBillModal">
            <div className="modal-overlay">
                <div className="modal-content">
                    <h2>Generate Revised Bill</h2>

                    {/* Remarks Section */}
                    <div className="remarks-section">
                        <h3>Additional Remarks (Max {maxRemarks})</h3>
                        {/* Validation errors */}
                        {validationErrors.length > 0 && (
                            <div className="validation-errors">
                                {validationErrors.map((error, i) => (
                                    <div key={i} className="error-message">⚠️ {error}</div>
                                ))}
                            </div>
                        )}

                        {remarks.map((remark, index) => (
                            <div key={index} className="remark-row">
                                <input
                                    type="text"
                                    placeholder={`Other expenses ${index + 1}`}
                                    value={remark.text}
                                    onChange={(e) => handleRemarkChange(index, 'text', e.target.value)}
                                    maxLength={20}
                                />
                                <input
                                    type="number"
                                    placeholder={`Amount ${index + 1}`}
                                    value={remark.amount}
                                    onChange={(e) => handleRemarkChange(index, 'amount', e.target.value)}
                                />
                            </div>
                        ))}
                        <div className="remark-buttons">
                            <button
                                onClick={handleAddRemark}
                                disabled={remarks.length >= maxRemarks}
                            >
                                Add
                            </button>
                            <button onClick={handleClearRemarks}>
                                Clear
                            </button>
                        </div>

                        {/* <div className="tax-checkbox">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={applyTaxes}
                                    onChange={(e) => setApplyTaxes(e.target.checked)}
                                />
                                Please select the checkbox to apply CGST and SGST
                            </label>
                        </div> */}
                    </div>

                    {/* Action Buttons */}
                    <div className="modal-actions">
                        <button className="generate-btn" onClick={handleGenerate}>
                            Generate
                        </button>
                        <button
                            className="cancel-btn"
                            onClick={() => setShowConfirm(true)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>

                {/* Confirm Cancel Modal */}
                {showConfirm && (
                    <div className="confirm-overlay">
                        <div className="confirm-content">
                            <h3>Are you sure?</h3>
                            <p>This will clear your current selections.</p>
                            <div className="confirm-actions">
                                <button onClick={() => { onClose(); setShowConfirm(false); }}>
                                    Yes
                                </button>
                                <button onClick={() => setShowConfirm(false)}>
                                    No
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GenerateRevisedBillModal;